/// <reference path="../../global.ts" />
import React, { useCallback, useState } from "react";
import { Question, type QuestionWithAnswer } from "./Question";

export interface QuestionList {
  slug: string;
  title: string;
  description?: string;
  questions: QuestionWithAnswer[];
}

interface Props {
  questionLists: QuestionList[];
}

type Dictionary<T> = Partial<Record<string, T>>;

export const QuestionAnswerAccordion: React.FC<Props> = ({
  questionLists,
}) => {
  const [expandedAnswers, setExpandedAnswers] = useState<Dictionary<string[]>>({});

  const handleQuestionClick = useCallback((setSlug: string, slug: string) => {
    if (expandedAnswers[setSlug]?.includes(slug)) {
      setExpandedAnswers({
        ...expandedAnswers,
        [setSlug]: expandedAnswers[setSlug]?.filter((q) => q !== slug),
      });
    } else {
      setExpandedAnswers({
        ...expandedAnswers,
        [setSlug]: [...(expandedAnswers[setSlug] || []), slug],
      });
    }
  }, [expandedAnswers]);

  const onExpandAll = useCallback((slug: string) => {
    const questionList = questionLists.find(set => set.slug === slug);
    if (!questionList) return;

    const allQuestionSlugs = questionList.questions.map(({ slug }) => slug);
    setExpandedAnswers({
      ...expandedAnswers,
      [slug]: allQuestionSlugs,
    });
  }, [questionLists]);

  const onCollapseAll = useCallback((slug: string) => {
    setExpandedAnswers({
      ...expandedAnswers,
      [slug]: [],
    });
  }, []);

  return (
    <div className="accordionWrapper">
      <div className="accordionBody">
      { questionLists.map(({ title, description, questions, slug }) => (
        <div className="faqList pb-3">
          <h3 className="mt-4 mb-2" id={slug} dangerouslySetInnerHTML={{ __html: title }} />
          {description}
          <div className="listActions mb-1">
            <button onClick={() => onExpandAll(slug)} disabled={expandedAnswers[slug]?.length === questions.length}>{window.gettext("Expand all")}</button>
            <button onClick={() => onCollapseAll(slug)} disabled={(expandedAnswers[slug] ?? []).length === 0}>{window.gettext("Collapse all")}</button>
          </div>
          {questions.map(({ question, answer, slug: questionSlug }) => (
            <Question
              answer={answer}
              isAnswerVisible={expandedAnswers[slug]?.includes(questionSlug) ?? false}
              key={questionSlug}
              question={question}
              questionClickHandler={() => {
                handleQuestionClick(slug, questionSlug)
              }}
              slug={questionSlug}
            />
          ))}
        </div>
      ))}
      </div>
    </div>
  );
};

